const validateEmail = (email) => {
  const regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
  return regex.test(email) && !/\.\./.test(email);
};

const validateName = (name) => {
  const regName = /^[A-Za-z\s]+$/;
  return regName.test(name);
};

const validateNameWithNum = (orgName) => {
  const regOrgName = /^[A-Za-z0-9\s&.-]+$/;
  const isValid = regOrgName.test(orgName);
  return isValid;
};

const validateAmount = (value) => {
  const regex = /^[0-9]*$/;
  return regex.test(value);
};

const validateMobileNumber = (mobile) => {
  const regMobile = /^[0-9]{10}$/;
  return regMobile.test(mobile);
};

const spaceCheck = (value) => {
  const inputCheck = /^\s+|\s+$/g;
  // const inputCheck = /^[a-zA-Z\s]+$/;
  return inputCheck.test(value);
};

const englishRegex = (value) => {
  const text = /^[a-zA-Z0-9\s!@#$%^&*()?:';"[\],./|\\{}<>+_=-]*$/;
  return text.test(value);
};

const validateRoleName = (value) => {
  const roleName = /^[A-Za-z ]+$/;
  return roleName.test(value);
};

// Function to get a cookie value
const getCookie = (name) => {
  const cookie = {};
  document.cookie.split(";").forEach(function (el) {
    const [k, v] = el.split("=");
    cookie[k.trim()] = v;
  });
  return cookie[name];
};

// Function to delete a cookie
const deleteCookie = (name) => {
  document.cookie = name + "=; expires=" + new Date(0).toUTCString() + ";";
};

// Function to create a cookie
const createCookie = (name, value, days) => {
  let expires = "";

  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  } else {
    expires = "";
  }

  document.cookie = name + "=" + value + expires + "; path=/";
};
const capitalLetterValidate = (password) => {
  const reg = /[A-Z]/;
  return reg.test(password);
};

const lowercaseLetterValidate = (password) => {
  const reg = /[a-z]/;
  return reg.test(password);
};

const singleNumber = (password) => {
  const reg = /\d/;
  return reg.test(password);
};

const miniCharacters = (password) => {
  const passwordRegex = /^.{8,}$/;
  return passwordRegex.test(password);
};

const specialCharacter = (password) => {
  const passwordRegex = /[~@#$%^&*()]/;
  return passwordRegex.test(password);
};

export {
  validateEmail,
  validateName,
  validateMobileNumber,
  getCookie,
  deleteCookie,
  createCookie,
  spaceCheck,
  englishRegex,
  validateRoleName,
  capitalLetterValidate,
  lowercaseLetterValidate,
  singleNumber,
  miniCharacters,
  specialCharacter,
  validateAmount,
  validateNameWithNum,
};
